<template>
	<div>
		<div class="community_content">
			<p class="community_hello">Hello Alan Walker,  Welcome Back</p>
			<div class="community_box">
				<p>THE <span>MD SCHOOL</span></p>
				<p>OF <span>BUSINESS</span> AND</p>
				<p><span>ECONOMICS</span><label></label></p>
				<div v-if="!download_show&&!comment_active" class="download" @click="download">
					<svg preserveAspectRatio="xMidYMid meet" data-bbox="46.5 53.605 107.001 91.997" viewBox="46.500423431396484 53.6049919128418 107.000732421875 91.99668884277344" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
						<g>
							<path d="M141.796 86.941a30.774 30.774 0 0 0-.177-7.123c-1.952-13.646-12.874-24.335-26.565-25.994-10.476-1.27-20.894 3.049-27.478 11.251-.064-.012-.126-.036-.19-.047a19.332 19.332 0 0 0-14.551 3.201 19.356 19.356 0 0 0-8.32 15.934h-.11c-8.505 0-15.979 6.104-17.506 14.675-1.717 9.649 2.179 18.062 10.421 22.504l.255.137c2.832 1.536 5.028 2.729 20.843 2.729 3.766 0 8.31-.067 13.813-.215a1.722 1.722 0 0 0 1.677-1.768c-.027-.951-.893-1.743-1.767-1.678-27.693.734-30.116-.579-32.924-2.1l-.262-.142c-6.97-3.756-10.127-10.63-8.662-18.864 1.333-7.484 8.3-12.643 15.834-11.727a1.746 1.746 0 0 0 1.412-.482c.372-.367.559-.884.507-1.405a16.033 16.033 0 0 1 .155-4.436 15.932 15.932 0 0 1 6.606-10.336c3.511-2.448 7.766-3.389 11.976-2.633a15.964 15.964 0 0 1 7.574 3.596 1.725 1.725 0 0 0 2.241-2.622c-1.617-1.383-3.456-2.447-5.408-3.233 5.868-6.568 14.626-9.99 23.451-8.917 12.146 1.472 21.838 10.954 23.565 23.059.337 2.345.362 4.741.055 7.224l-.05.285a1.725 1.725 0 0 0 1.138 1.868c7.035 2.467 11.489 9.634 10.594 17.043-1.008 8.311-8.595 14.126-18 13.974-4.946-.112-17.411-.157-23.995-.165h-.002a1.725 1.725 0 0 0-.003 3.449c6.571.007 19.003.052 23.92.162.195.005.389.007.581.007 10.96 0 19.715-7.079 20.918-17.013 1.034-8.534-3.78-16.807-11.566-20.198z" fill="#45C6C9" data-color="1"></path>
							<path d="M106.018 135.241l-4.23 4.375V92.128c0-.951-.774-1.726-1.724-1.726s-1.724.774-1.724 1.726v47.488l-4.23-4.375a1.724 1.724 0 0 0-2.476 2.397l7.192 7.439c.002.003.007.004.009.006a1.713 1.713 0 0 0 2.456 0l.009-.006 7.192-7.439a1.724 1.724 0 0 0-.04-2.437 1.719 1.719 0 0 0-2.434.04z" fill="#45C6C9" data-color="1"></path>
						</g>
					</svg>
					<p>资料下载</p>
				</div>
				<ul v-if="!download_show">
					<li v-for="(item,index) in list" :key="index" @click="comment">
						<dl>
							<dd>{{item.title}}</dd>
							<dd>
								<svg preserveAspectRatio="xMidYMid meet" data-bbox="37.5 15.1 125 169.9" viewBox="37.5 15.099998474121094 125 169.89996337890625" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
									<g>
										<path d="M148 98.9c-7.6-6.4-17.8-10.5-30.4-12.4 12-6.4 20.2-19 20.2-33.5 0-20.9-17-37.9-37.8-37.9S62.2 32 62.2 52.9c0 14.6 8.3 27.3 20.4 33.6-12.5 2.1-22.9 6.5-30.7 13.2-9.2 7.9-14.4 18.7-14.4 29.9v40.1c0 1.7 1 6 9.8 9.4 9.9 3.9 27.2 5.9 51.2 5.9 25.3 0 43.4-2 53.8-5.9 8.9-3.3 10.2-7.4 10.2-9.5v-39.4c0-8.8-2.5-21.4-14.5-31.3zm-77.6-46c0-16.3 13.3-29.6 29.6-29.6s29.6 13.3 29.6 29.6-13.3 29.6-29.6 29.6-29.6-13.3-29.6-29.6zm83.9 115.9c-1.4 1.4-10.5 8.1-55.8 8.1-43 0-51.5-6.7-52.7-8v-39.4c0-18 16.8-36.1 54.3-36.1 19 0 33.4 4 42.8 11.7 9.5 8 11.5 18.1 11.5 25.2l-.1 38.5z" fill="#29abe2" data-color="1"></path>
									</g>
								</svg>
								<span>{{item.author}}</span>
							</dd>
							<dd>
								<svg preserveAspectRatio="xMidYMid meet" data-bbox="20.5 27.5 159 145" viewBox="15.82352941176471 20.5 168.35294117647058 159" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="img" style="stroke-width: 1px;">
									<g>
										<path d="M179.5 89.133c0 32.438-18.159 57.416-50.694 57.416H77.139C38.659 144.387 20.5 172.5 20.5 172.5V89.349C20.5 46.747 44.712 27.5 76.166 27.5h52.748c32.427.108 50.586 25.086 50.586 61.633z"></path>
									</g>
								</svg>
								<span>{{item.comment}}</span>
							</dd>
							<dd>
								<svg preserveAspectRatio="xMidYMid meet" data-bbox="39.999 39.5 120 121" viewBox="39.99869155883789 39.5 119.99957275390625 121" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
									<g>
										<path d="M100.023 39.5c-.392 0-.782.004-1.174.013-16.024.308-30.969 6.891-42.084 18.536-11.11 11.643-17.062 26.954-16.755 43.114.62 32.717 27.519 59.337 59.965 59.337.39 0 .782-.005 1.171-.011 16.024-.308 30.969-6.893 42.084-18.536 11.112-11.647 17.063-26.956 16.757-43.114-.62-32.718-27.52-59.339-59.964-59.339zm37.188 96.609c-9.564 10.024-22.43 15.691-36.222 15.957-.337.007-.675.011-1.012.011-27.927 0-51.077-22.912-51.612-51.077-.263-13.907 4.859-27.088 14.423-37.11 9.566-10.022 22.428-15.689 36.222-15.957.339-.007.675-.009 1.014-.009 27.924 0 51.077 22.912 51.61 51.077.265 13.905-4.857 27.084-14.423 37.108z" fill="#2F54DD" data-color="1"></path>
										<path fill="#2F54DD" d="M104.178 62.848H95.82v41.363h31.694v-8.422h-23.336V62.848z" data-color="1"></path>
									</g>
								</svg>
								<span>{{item.time}}</span>
							</dd>
						</dl>
					</li>
				</ul>
				<ul v-if="download_show" class="download_content">
					<li v-for="i in 5" :key="i">
						<dl>
							<dd>​CFA考试题库大全</dd>
							<dd>
								<button>下载</button>
							</dd>
						</dl>
					</li>
				</ul>
				<!--评论内容	-->
				<div v-if="comment_active" class="comment_box">
					<div class="comment_box_main">
						<!--帖子内容  start-->
						<div class="comment_box_main_left">
							<img :src="comment_content.blogger.userImg">
							<p>{{comment_content.blogger.user_name}}</p>
						</div>
						<div class="comment_box_main_right">
							<p>{{comment_content.blogger.title}}</p>
							<p>
								<svg preserveAspectRatio="xMidYMid meet" data-bbox="39.999 39.5 120 121" viewBox="39.99869155883789 39.5 119.99957275390625 121" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
									<g>
										<path d="M100.023 39.5c-.392 0-.782.004-1.174.013-16.024.308-30.969 6.891-42.084 18.536-11.11 11.643-17.062 26.954-16.755 43.114.62 32.717 27.519 59.337 59.965 59.337.39 0 .782-.005 1.171-.011 16.024-.308 30.969-6.893 42.084-18.536 11.112-11.647 17.063-26.956 16.757-43.114-.62-32.718-27.52-59.339-59.964-59.339zm37.188 96.609c-9.564 10.024-22.43 15.691-36.222 15.957-.337.007-.675.011-1.012.011-27.927 0-51.077-22.912-51.612-51.077-.263-13.907 4.859-27.088 14.423-37.11 9.566-10.022 22.428-15.689 36.222-15.957.339-.007.675-.009 1.014-.009 27.924 0 51.077 22.912 51.61 51.077.265 13.905-4.857 27.084-14.423 37.108z" fill="#2F54DD" data-color="1"></path>
										<path fill="#2F54DD" d="M104.178 62.848H95.82v41.363h31.694v-8.422h-23.336V62.848z" data-color="1"></path>
									</g>
								</svg>
								<span>{{comment_content.blogger.time}}</span>
							</p>
							<p>
								{{comment_content.blogger.content}}
							</p>
							<div v-show="typeof comment_content.blogger.imgList!='undefined'" v-if="comment_content.blogger.imgList.length>0" class="comment_content_blogger_img">
								<img v-for="(item,index) in comment_content.blogger.imgList" :src="item" :key="index" @click="img_look(item)">
							</div>
							<div v-if="comment_item!=0" class="comment_content_opt">
								<ul>
									<li @click="to_comment('0')">
										<svg preserveAspectRatio="xMidYMid meet" data-bbox="20.5 27.5 159 145" viewBox="15.82352941176471 20.5 168.35294117647058 159" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="img" style="stroke-width: 1px;">
											<g>
												<path d="M179.5 89.133c0 32.438-18.159 57.416-50.694 57.416H77.139C38.659 144.387 20.5 172.5 20.5 172.5V89.349C20.5 46.747 44.712 27.5 76.166 27.5h52.748c32.427.108 50.586 25.086 50.586 61.633z"></path>
											</g>
										</svg>
									</li>
									<li>
										<svg preserveAspectRatio="xMidYMid meet" data-bbox="42 39.499 116 121" viewBox="42 39.499000549316406 115.99984741210938 120.99999237060547" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
											<g>
												<path d="M153.456 94.317c-3.926-5.122-9.922-7.943-16.878-7.943h-12.117c4.984-10.908 5.154-26.807 1.188-36.237-2.887-6.862-7.829-10.638-13.919-10.638-1.652 0-3.381.29-5.14.855-8.689 2.802-9.015 9.724-9.303 15.83-.42 8.874-1.056 21.923-23.628 38.773v-8.465H42v72.826h31.66v-9.008c5.418 4.908 13.13 10.189 21.245 10.189h36.611c7.637 0 15.169-5.777 17.152-13.15l8.222-30.59c2.272-8.452 1.021-16.634-3.434-22.442zm-88.219 56.579H50.423V94.92h14.814v55.976zm83.517-36.324l-8.222 30.592c-.989 3.685-5.201 6.911-9.015 6.911H94.905c-7.958 0-17.306-9.198-21.245-13.896v-32.876c30.727-20.874 31.546-38.253 32.042-48.721.304-6.46.663-7.302 3.472-8.211.922-.297 1.784-.447 2.557-.447 2.555 0 4.622 1.844 6.152 5.48 4.2 9.986 2.012 27.905-4.183 34.236l-7.003 7.157h29.88c4.339 0 7.865 1.605 10.192 4.644 2.849 3.716 3.572 9.227 1.985 15.131z" fill="#2F54DD" data-color="1"></path>
											</g>
										</svg>
									</li>
									<li>
										<svg preserveAspectRatio="xMidYMid meet" data-bbox="10 10 179.999 179.999" viewBox="10 10 179.99900817871094 179.99899291992188" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
											<g>
												<path d="M64.04 10c-1.457 0-3.444.794-4.503 1.853L11.854 59.5C10.795 60.559 10 62.676 10 64.132v71.735c0 1.456.795 3.441 1.854 4.5l47.682 47.779c1.06 1.059 3.046 1.853 4.503 1.853h71.788c1.457 0 3.444-.794 4.503-1.853l47.815-47.779c1.06-1.059 1.854-3.044 1.854-4.5V64.132c0-1.456-.795-3.441-1.854-4.5L140.33 11.985c-.926-1.191-2.913-1.985-4.37-1.985H64.04zm35.164 152.735a13.331 13.331 0 0 1-13.368-13.368 13.331 13.331 0 0 1 13.368-13.368 13.331 13.331 0 0 1 13.368 13.368c-.001 7.28-5.956 13.368-13.368 13.368zm15.62-123.22c-.132 1.456-.265 3.838-.265 5.294v22.368c0 30.309-8.603 52.809-8.603 52.809-.529 1.324-2.118 2.515-3.574 2.515h-4.765c-1.456 0-3.044-1.059-3.574-2.515 0 0-8.603-22.632-8.603-52.676V39.648s0-1.985 4.765-1.985 14.426-.265 19.721-.265c5.295-.133 4.898 2.117 4.898 2.117z" fill="#FF0000" data-color="1"></path>
											</g>
										</svg>
									</li>
								</ul>
							</div>
							<!--发表评论:对发帖人的第一条评论 comment_item=0   @keyup="code_comment"-->
							<div v-if="comment_item==0" class="create_comment">
								<textarea type="text" v-model="comment_post"></textarea>
								<div class="comment_btn">
									<button @click="comment_send">发布</button>
									<button @click="comment_cancel">取消</button>
								</div>
							</div>
							<!--帖子内容评论  start-->
							<div class="comment_content_list">
								<ul>
									<li v-for="(list,index) in comment_content.comment_list" :key="index">
										<p>回复：</p>
										<p>
											<svg preserveAspectRatio="xMidYMid meet" data-bbox="39.999 39.5 120 121" viewBox="39.99869155883789 39.5 119.99957275390625 121" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" style="">
												<g>
													<path d="M100.023 39.5c-.392 0-.782.004-1.174.013-16.024.308-30.969 6.891-42.084 18.536-11.11 11.643-17.062 26.954-16.755 43.114.62 32.717 27.519 59.337 59.965 59.337.39 0 .782-.005 1.171-.011 16.024-.308 30.969-6.893 42.084-18.536 11.112-11.647 17.063-26.956 16.757-43.114-.62-32.718-27.52-59.339-59.964-59.339zm37.188 96.609c-9.564 10.024-22.43 15.691-36.222 15.957-.337.007-.675.011-1.012.011-27.927 0-51.077-22.912-51.612-51.077-.263-13.907 4.859-27.088 14.423-37.11 9.566-10.022 22.428-15.689 36.222-15.957.339-.007.675-.009 1.014-.009 27.924 0 51.077 22.912 51.61 51.077.265 13.905-4.857 27.084-14.423 37.108z" fill="#2F54DD" data-color="1"></path>
													<path fill="#2F54DD" d="M104.178 62.848H95.82v41.363h31.694v-8.422h-23.336V62.848z" data-color="1"></path>
												</g>
											</svg>
											<span>{{list.time}}</span>
										</p>
										<p>
											<img :src="list.photo"><span>{{comment_content.blogger.content}}</span>
										</p>
										<!-- <div v-show="typeof comment_content.blogger.imgList!='undefined'" v-if="comment_content.blogger.imgList.length>0" class="comment_content_blogger_img">
											<img v-for="(item,index) in comment_content.blogger.imgList" :src="item" :key="index" @click="img_look(item)">
										</div> -->
										
									</li>
								</ul>
							</div>
							
							<!--帖子内容评论  end-->
						</div>
					</div>
					<!--帖子内容  end-->
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default {
	  name: 'Community_one',
	  data () {
	    return {
			download_show:false,
			comment_active:false,
			comment_item:-1,//-1:没有要评论的；0：对发帖人的第一条评论 1：评论列表的第一条评论.。。。。。
			list:[{
				title:'线性代数是什么意思',
				author:'Jeremy',
				comment:'21',
				time:'五分钟前'
			},{
				title:'线性代数是什么意思',
				author:'Jeremy',
				comment:'21',
				time:'五分钟前'
			},{
				title:'线性代数是什么意思',
				author:'Jeremy',
				comment:'21',
				time:'五分钟前'
			},{
				title:'线性代数是什么意思',
				author:'Jeremy',
				comment:'21',
				time:'五分钟前'
			}],
			comment_content:{
				blogger:{
					userImg:'https://static.wixstatic.com/media/ff6eb63982814649a8a7f694f12131b4.jpg/v1/crop/x_950,y_0,w_3800,h_3800/fill/w_37,h_37,al_c,q_80,usm_0.66_1.00_0.01/Smiling%20Businessman.webp',
					user_name:'Jerrmy',
					title:'线性代数是什么意思？（帖子题目）',
					time:'五分钟前',
					content:'线性代数是数学的一个分支，它的研究对象是向量，向量空间（或称线性空间），线性变换和有限维的线性方程组。向量空间是现代数学的一个重要课题；因而，线性代数被广泛地应用于抽象代数和泛函分析中；通过解析几何，线性代数得以被具体表示。线性代数的理论已被泛化为算子理论。由于科学研究中的非线性模型通常可以被近似为线性模型，使得线性代数被广泛地应用于自然科学和社会科学中。（具体的问题）',
					imgList:[
						'http://baiducdn.pig66.com/uploadfile/2017/0511/20170511074206666.jpg',
// 						'http://img.zcool.cn/community/011e0755684869000001271638b6e0.jpg@1280w_1l_2o_100sh.jpg',
// 						'http://up.enterdesk.com/edpic/4e/cd/d8/4ecdd872a11b0fd24e950f8f8b5ff930.jpg',
					]
				},
				comment_list:[{
					photo:'https://static.wixstatic.com/media/e912a4f13acb34a19a4b83b8d1fdfa40.png/v1/crop/x_15,y_0,w_144,h_144/fill/w_21,h_21,al_c,q_80,usm_0.66_1.00_0.01/Businessman.webp',
					time:'五分钟前',
					content:'线性代数是数学的一个分支，它的研究对象是向量，向量空间（或称线性空间），线性变换和有限维的线性方程组。向量空间是现代数学的一个重要课题；因而，线性代数被广泛地应用于抽象代数和泛函分析中；通过解析几何，线性代数得以被具体表示。线性代数的理论已被泛化为算子理论。由于科学研究中的非线性模型通常可以被近似为线性模型，使得线性代数被广泛地应用于自然科学和社会科学中。（回复1）',
					imgList:[
						'http://baiducdn.pig66.com/uploadfile/2017/0511/20170511074206666.jpg',
// 						'http://img.zcool.cn/community/011e0755684869000001271638b6e0.jpg@1280w_1l_2o_100sh.jpg',
// 						'http://up.enterdesk.com/edpic/4e/cd/d8/4ecdd872a11b0fd24e950f8f8b5ff930.jpg',
					]
				},{
					photo:'https://static.wixstatic.com/media/ff6eb63982814649a8a7f694f12131b4.jpg/v1/crop/x_950,y_0,w_3800,h_3800/fill/w_37,h_37,al_c,q_80,usm_0.66_1.00_0.01/Smiling%20Businessman.webp',
					time:'五分钟前',
					content:'线性代数是数学的一个分支，它的研究对象是向量，向量空间（或称线性空间），线性变换和有限维的线性方程组。向量空间是现代数学的一个重要课题；因而，线性代数被广泛地应用于抽象代数和泛函分析中；通过解析几何，线性代数得以被具体表示。线性代数的理论已被泛化为算子理论。由于科学研究中的非线性模型通常可以被近似为线性模型，使得线性代数被广泛地应用于自然科学和社会科学中。（回复1）'
				}]
			},
			comment_post:'',//要发布的评论
	    }
	  },
	  methods:{
		  download:function(){
			  this.download_show = !this.download_show
		  },
		  //查看评论
		  comment:function(){
			   //清空列表
			  this.list = []
			  this.download_show = false
			  this.comment_active = true
			 
		  },
		  //查看图片
		  img_look:function(url){
			  window.open(url)
		  },
		  to_comment:function(comment_item_index){
			  //清空评论内容
			  this.comment_post = ""
			  this.comment_item = comment_item_index
		  },
// 		  //输入框只能输入中英文和数字
// 		  code_comment:function(){
// 			  //此方法不能输入中文的 ， 。
// 			  // this.comment_post = this.comment_post.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g, '');
// 		  },
		  comment_send:function(){
			  alert("发布成功")
			  //发布成功，关闭评论区域
			  this.comment_cancel()
		  },
		  //关闭评论
		  comment_cancel:function(){
			  this.comment_item = -1
		  }
	  }
	}
</script>

<style scoped="scoped">
	@import '../../../static/css/community.css';
	
	.person_page{
		min-width: 1024px;
		background-color: rgb(100,101,112);
	}
	
	.nav_content{
		width: 220px;
		min-height: 200px;
		margin:0 auto;
		position: absolute;
		margin-top:200px;
	}
	.nav_content .user_photo{
		width: 100px;
		height: 100px;
		position: absolute;
		margin-top:-40px;
		border-radius: 50%;
		margin-left: 60px;
		border:2px #fff solid;
	}
	.nav_content .nav_content_box{
		width: 220px;
		min-height: 200px;
		background-color: rgba(45,47,58,0.5);
		border-radius: 20px;
	}
	.nav_content .nav_content_box .user_name{
		width: 180px;
		height:20px;
		margin:0 auto;
		padding-top:70px;
		padding-bottom:10px;
		font-size: 15px;
		color:rgba(199,199,199);
		text-align: center;
		border-bottom:1px rgba(199,199,199) solid;
	}	
	.nav_content .nav_content_box ul{
		width: 100%;
		overflow: hidden;
		zoom:1;
		padding-bottom:20px;
		margin-top:10px;
	}
	.nav_content .nav_content_box ul li{
		width:100%;
		height: 40px;
		line-height: 40px;
		display: block;
		text-align: center;
	}	
	.nav_content .nav_content_box ul li p{
		font-size: 14px;
		color:rgba(199,199,199);
		cursor:pointer;
	}
	.nav_content .nav_content_box ul li span{
		padding:1px 4px;
		width: 10px;
		line-height: initial;
		background: #FF5252;
		color:#fff;
		font-size:12px;
		border-radius: 100%;
		margin-top: -35px;
		margin-left:2px;
		margin-left: 30px;
		position: absolute;
	}
	.nav_content_item_active p{
		color:rgba(255,255,255) !important;
	}
	.person_components{
		width: 750px;
		min-height:200px;
		position: relative;
		margin-top:200px;
		float: right;
		right:50px;
	}
</style>



// WEBPACK FOOTER //
// src/components/community/Community_one.vue